import { LEGAL_DOCUMENT_TYPES } from '@api/hooks/useProfiles';
import { LegalDocumentTabs } from '@components/LegalConsent/LegalDocumentTabs';
import { PageContainer } from '@components/PageContainer';
import { useCCFeatureFlagsContext } from '@contexts/CCFeatureFlagContext';
import { LinkItem, List } from '@gurupay/gp-ui-library';
import { useTranslation } from 'react-i18next';
import { CC_FEATURE_FLAGS } from 'types/layout';

interface LegalDocument {
	titleKey: string;
	linkKey: string;
}

const documentsList: LegalDocument[] = [
	{
		titleKey: 'privacyPolicy',
		linkKey: 'privacyPolicyLink',
	},
	{
		titleKey: 'termsAndCondition',
		linkKey: 'termsAndConditionLink',
	},
];

export const LegalDocuments = () => {
	const { t } = useTranslation('', { keyPrefix: 'legalDocuments' });
	const { hasFeature } = useCCFeatureFlagsContext();

	return (
		<PageContainer backUrl={'/settings'} title={t('title')}>
			{hasFeature(CC_FEATURE_FLAGS.LEGAL_CONSENT_SCREEN) ? (
				<div className="m-auto max-w-lg">
					<LegalDocumentTabs
						heightClassName="h-[calc(100dvh-20rem)] min-h-80"
						types={LEGAL_DOCUMENT_TYPES}
					/>
				</div>
			) : (
				<List className="m-auto max-w-lg">
					{documentsList.map((document) => (
						<LinkItem
							key={document.titleKey}
							isNewTab
							link={t(document.linkKey)}
							title={t(document.titleKey)}
						/>
					))}
				</List>
			)}
		</PageContainer>
	);
};
